<template>

  <div>
    <head-top></head-top>
    <el-row style="margin-top: 20px;" v-loading="loading">
      <el-col :span="20">
        <el-form :model="formData"  ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="formData.name" maxlength="15" placeholder="不超过15字，不能有特殊字符或空格" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="商品分类" prop="classify" >
            <el-select v-model="formData.classify" placeholder="请选择" style="width: 200px">
              <el-option
                v-for="item in options"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否上架" prop="sell" >
            <el-select v-model="formData.sell" placeholder="请选择" style="width: 200px">
              <el-option
                v-for="item in option"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库存数量" prop="stock">
            <el-input v-model="formData.stock" value="1" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="积分数量" prop="number">
            <el-input v-model="formData.number" value="1" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="商品封面" prop="img" >
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='handlesuccess'
              :before-upload="beforeUploadimg"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:1}"
              :on-exceed="handleExceed">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="详情图片" prop="img" >
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='handlesuccesss'
              :before-upload="beforeUploadimg"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:1}"
              :on-exceed="handleExceed">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="商品描述">
            <el-button size="small" type="primary"  @click="dialogFormVisible4 = true">添加描述</el-button>

          </el-form-item>
          <el-table
            :data="tableData"
            style="width: 100%;margin-left:60px;">
            <el-table-column
              type="index"
              label="序号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="description"
              label="描述"
              width="180">
            </el-table-column>
            <el-table-column
              prop="imageUrl"
              label="图片地址">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="Viewmaterials(scope.$index, scope.row)">查看</el-button>
                <el-button size="mini" type="text" @click="Editmaterial(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--添加图文教程-->
          <el-dialog title="添加商品" :visible.sync="dialogFormVisible4">
            <el-form>
              <el-form-item label="描述" :label-width="formLabelWidth">
                <el-input v-model="Godaddy.name"  type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='Godaddysuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="Godaddy.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel1">取 消</el-button>
              <el-button type="primary" @click="Godaddys()">确 定</el-button>
            </div>
          </el-dialog>
          <!--查看图文教程-->
          <el-dialog title="查看商品" :visible.sync="dialogFormVisible5">
            <el-form >
              <el-form-item label="描述" width="300px">
                <span>{{Godaddy.name}}</span>
              </el-form-item>
              <el-form-item label="图片附件" class="mar" >
                <img v-bind:src="Godaddy.img" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" >
              <el-button @click="dialogFormVisible5 = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible5 = false">确 定</el-button>
            </div>
          </el-dialog>
          <!--编辑图文教程-->
          <el-dialog title="编辑商品" :visible.sync="dialogFormVisible6">
            <el-form>
              <el-form-item label="课程描述" :label-width="formLabelWidth">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="Godaddy.name">
                </el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='Godaddysuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="Godaddy.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <div slot="tip" class="el-upload__tip">请上传688×326的jpg/png图片，且不超过500kb</div>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="图片附件:" prop="img" :label-width="formLabelWidth">
                <img v-bind:src="Godaddy.img" style="width: 80%">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible4 = false">取 消</el-button>
              <el-button type="primary" @click="Godaddysubmit()">确 定</el-button>
            </div>
          </el-dialog>
          <div class="but_bot">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import { getComclassification,getAddgoods } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        options: [],
        option:[{
          value: '0',
          label: '下架',
        }, {
          value: '1',
          label: '上架',
        }],
        detailContent: '',// 富文本内容
        formData: {},
        formLabelWidth: '80px',
        imageUrl:'',
        detailsImage:'',
        currentPage:1,
        limit:20,
        tableData:[],
        dialogFormVisible4:false,
        dialogFormVisible5:false,
        dialogFormVisible6:false,
        Godaddy:{
          name:'',
          img:''
        },
        fileList:[],
        inde:0,
        myHeaders: {token: sessionStorage.token},
        loading:false
      }
    },
    components: {
      headTop,
    },
    methods:{
      getComclassification(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        //获取商品分类列表
        getComclassification(params).then(res=>{
          this.options = res.pageInfo
        }).catch(error=>{
          console.log(error);
        })
      },
      handlesuccess(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.imageUrl = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
       handlesuccesss(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.detailsImage = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      Godaddysuccess(response, file, fileList){
        if(file.response.state == true){
          this.Godaddy.img = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      handleExceed(files, fileList) {
        this.$message.warning(`最多上传一张封面`);
      },
      handleRemove(file, fileList) {
        this.form.img = ''
        this.Godaddy.img = ''
      },
      beforeUploadimg(file) {
        if (['image/jpg', 'image/png', 'image/jpeg', 'image/gif'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的图片格式');
          return false
        }
      },
      Viewmaterials(index,row){
        //  查看商品描述
        this.dialogFormVisible5 = true
        this.Godaddy.name = row.description,
        this.Godaddy.img = row.imageUrl
      },
      //  删除商品描述
      handleDelete(index,row){
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          this.tableData.splice(index, 1);
        }).catch(() => {
        })
      },
      Godaddys(){
        const tableData = {}
        tableData.sort = (this.inde)++
        tableData.description = this.Godaddy.name.replace(/ /g, "/t");
        tableData.imageUrl = this.Godaddy.img;
        this.tableData.push(tableData);
        this.Godaddy = {
          name: '',
          img: ''
        }
        this.fileList = [],
        this.dialogFormVisible4 = false
        // }
      },
      cancel1(){
        this.Godaddy = {
          name:'',
          img:''
        }
        this.fileList = [],
        this.dialogFormVisible4 = false
      },
      //提交
      submit(){
         if (this.formData.number <= 0 || this.formData.stock < 0){
              this.$message({
              type: 'error',
              message: '积分不能为负数和零，库存不能为负数'
            });
          }else {
            this.loading = true
            let params = {
              description:JSON.stringify(this.tableData),
              goodsName:this.formData.name,
              typeId:this.formData.classify,
              imageUrl:this.imageUrl,
              detailsImage:this.detailsImage,
              integral:this.formData.number,
              operationId:JSON.parse(sessionStorage.getItem('user')).id,
              sell:this.formData.sell,
              stock:this.formData.stock
            }
            getAddgoods(params).then(res=>{
              if (res.state == true) {
                this.$message({
                  type: 'success',
                  message: res.msg
                });
                this.loading = false
              }else{
                this.$message({
                  type: 'error',
                  message: '请上传正确信息'
                });
                this.loading = false
              }
            }).catch(error=>{
              this.loading = false
              console.log(error)
            })
          }
      },
      Editmaterial(index,row){
        //  编辑商品描述
        this.dialogFormVisible6 = true
        this.Godaddy.name = row.description
        this.Godaddy.img = row.imageUrl
        this.Godaddy.sort = row.sort
      },
      Godaddysubmit(index,row){
        const tablesDatas={}
        tablesDatas.sort = (this.inde)++
        tablesDatas.description = this.Godaddy.name.replace(/ /g, "/t")
        tablesDatas.imageUrl = this.Godaddy.img
        this.tableData.splice(index, 1)
        this.tableData.push(tablesDatas)
        this.Godaddy = {
          name:'',
          img:''
        }
        this.fileList = []
        this.dialogFormVisible6 = false
      },
      //取消
      cancel(){
        this.reload()
        this.$router.push('management')
      },
    },
    activated () {
      this.getComclassification()
    },
  }
</script>
<style>
  .edit_container{
    padding: 40px;
    margin-bottom: 40px;
  }
  .editer{
    height: 300px;
  }
  .mar{
    margin-top:20px;
  }
</style>




// WEBPACK FOOTER //
// src/page/addGoods.vue